import styled from "@mui/material/styles/styled";

import Stack from "@rui/Stack";

export const Container = styled(Stack)(({ theme }) => ({
  width: "100%",
  flexDirection: "column",
  alignItems: "stretch",
  minHeight: "100vh",
  flexGrow: "1",
  backgroundColor: "#fff",

  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
  },
}));

export const Column = styled(Stack)(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",
  width: "100%",

  [theme.breakpoints.up("md")]: {
    alignItems: "center",
    minHeight: "100vh",
  },
}));

export const LeftColumn = styled(Column)(({ theme }) => ({
  flexGrow: 1,
  width: "100%",
  [theme.breakpoints.up("md")]: {
    justifyContent: "flex-end",
    width: "50%",
  },
}));

export const LeftColumnContent = styled(Column)({
  maxWidth: "446px",
  padding: "24px",
});

export const RightColumn = styled(Column)(({ theme }) => ({
  backgroundColor: "#443FC4",
  padding: "40px",
  width: "100%",
  [theme.breakpoints.up("md")]: {
    width: "50%",
    justifyContent: "flex-start",
  },
}));

export const RightColumnContent = styled(Column)(({ theme }) => ({
  maxWidth: "600px",
  justifyContent: "center",
  [theme.breakpoints.up("md")]: {
    maxWidth: "100%",
  },
}));
